module.exports = "https://coursera_assets.s3.amazonaws.com/images/a06dc9905c94b686f418709b3a4d6c20.png";